import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import apiClient from '../../service/ApiClient.js';
import hotelSettingsService from '../../service/HotelSettingsService';
import { installLabelOverrides } from '../../i18n/labelOverrides';

/**
 * Renders nothing. Loads this hotel's label overrides (admine → Hotel
 * Settings → Labels) from the cached /v1/settings call and layers them
 * over the i18n bundles — see src/i18n/labelOverrides.js.
 */
const HotelLabelOverrides = () => {
  const { i18n } = useTranslation();
  // Mounted inside <Router>: login is an SPA navigate, so re-evaluate
  // auth on route changes and load once the session exists.
  useLocation();
  const authed = apiClient.isAuthenticated();

  useEffect(() => {
    if (!authed) return undefined;
    let cancelled = false;
    let uninstall = () => {};
    hotelSettingsService.getSettings()
      .then((res) => {
        if (cancelled) return;
        const settings = res?.data || res || {};
        // Effective = saved overrides expanded to every alias key the
        // backend knows (reports, lists, exports, print cards).
        const overrides = settings.labelOverridesEffective || settings.labelOverrides;
        if (overrides && typeof overrides === 'object' && Object.keys(overrides).length) {
          uninstall = installLabelOverrides(i18n, overrides);
        }
      })
      .catch(() => { /* default wording stays */ });
    return () => { cancelled = true; uninstall(); };
  }, [i18n, authed]);

  return null;
};

export default HotelLabelOverrides;
